import React from 'react';

const PlanCard = ({ duration, price }) => (
  <div className="bg-[#F7F9FD] rounded-lg p-4 shadow flex flex-col items-center">
    <h4 className="text-lg font-semibold text-[#55A55E]">{duration}</h4>
    <p className="text-2xl font-bold text-[#46824e] mt-2">{price}</p>
    <p className="text-sm text-gray-500 mt-1">Per {duration.includes('Month') ? 'Month' : 'Period'}</p>
  </div>
);

export default PlanCard;